import { useState } from "react";
import { faqs } from "@/mocks/portalData";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <p className="text-sm font-medium text-primary-600">常见问题 · FAQ</p>
          <h2 className="mt-1 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
            你可能想问的事
          </h2>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {faqs.map((f, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-xl border border-background-200/70 bg-background-50"
              >
                <button
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="font-heading text-base font-semibold text-foreground-900">{f.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700 transition-transform duration-300 ${
                      isOpen ? "rotate-45" : ""
                    }`}
                  >
                    <i className="ri-add-line text-lg"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="border-t border-background-200/60 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}